<template>
  <b-container fluid>
    <b-row class="my-2">
      <b-col class="col-left">
        <b-button
          v-if="content === 'table'"
          variant="warning"
          @click="contentHandler('form')"
        >
          สร้างโปรโมชั่น
        </b-button>
        <b-button
          v-if="content === 'form'"
          @click="backHandler"
        >
          ย้อนกลับ
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <promotion-table
          v-show="content === 'table'"
          :items.sync="items"
          :update-data-handler="updateDataHandler"
          :content-handler="contentHandler"
          :get-data-handler="getDataHandler"
          :delete-data-handler="deleteDataHandler"
        />
        <promotion-form
          v-show="content === 'form'"
          :item.sync="itemSelected"
          :create-data-handler="createDataHandler"
          :update-data-handler="updateDataHandler"
          :back-handler="backHandler"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import PromotionTable from "../../components/Settings/Promotion/PromotionTable";
  import PromotionForm from "../../components/Settings/Promotion/PromotionForm";
  import moment from 'moment'

  export default {
    name: "Promotion",
    components: {PromotionForm, PromotionTable},
    data() {
      return {
        items: [],
        itemSelected: {
          id: null,
          name: null,
          description: null,
          discount_type: 'percent', // percent, baht
          start_date: null,
          end_date: null,
          set_test_id: null,
          test_id: null,
          type: 'all', // each, all
          value: null,
          product_name: null,
          active: true,
        },
        content: 'table' // table, form
      }
    },
    watch: {
      'itemSelected.type'(value) {
        if (value === 'all') {
          this.itemSelected.test_id = null
          this.itemSelected.set_test_id = null
        }
      }
    },
    async mounted() {
      this.items = await this.fetchData() // fetch data axios
    },
    methods: {
      ...mapActions({
        'fetchData': 'Settings/getPromotions',
        'updateData': 'Settings/updatePromotion',
        'deleteData': 'Settings/deletePromotion',
        'createData': 'Settings/createPromotion',
        'getData': 'Settings/getPromotionById'

      }),
      async updateDataHandler(id, rowUpdate=null, password) {
        // add loading
        this.$store.state.isLoading = true
        // find selected item
        if (!rowUpdate) {
          rowUpdate = this.items.find(item => item.id === id)
          rowUpdate.start_date = moment(rowUpdate.start_date).unix()
          rowUpdate.end_date = moment(rowUpdate.end_date).unix()
        }
        // condition item not found
        if (!rowUpdate) {
          // show alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', 'id ไม่ถูกต้อง', 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        try {
          // update data axios
          await this.updateData({id: id, payload: rowUpdate, password })
        } catch (error) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        // fetch new data axios
        this.items = await this.fetchData()
        // alert update success
        await this.$swal.fire('สำเร็จ', 'แก้ไขข้อมูลสำเร็จ', 'success')
        // remove loading
        this.$store.state.isLoading = false
      },
      async createDataHandler(payload, password) {
        // add loading
        this.$store.state.isLoading = true
        try {
          // create data axios
          await this.createData({payload, password})
        } catch (error) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        // fetch new data axios
        this.items = await this.fetchData()
        // alert success
        await this.$swal.fire('สำเร็จ', 'แก้ไขข้อมูลสำเร็จ', 'success')
        // remove loading
        this.$store.state.isLoading = false
      },
      async deleteDataHandler(id, password) {
        // add loading
        this.$store.state.isLoading = true
        // find item
        const rowUpdate = this.items.find(item => item.id === id)
        // condition item not found
        if (!rowUpdate) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', 'id ไม่ถูกต้อง', 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        try {
          // delete data axios
          await this.deleteData({id, password})
        } catch (error) {
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
          this.$store.state.isLoading = false
          return
        }
        // fetch new data axios
        this.items = await this.fetchData()
        // alert success
        await this.$swal.fire('สำเร็จ', 'แก้ไขข้อมูลสำเร็จ', 'success')
        // remove loading
        this.$store.state.isLoading = false
      },
      contentHandler(content) {
        // change content page between 'form' and 'table'
        this.content = content
      },
      async getDataHandler(id) {
        let res
        try {
          // fetch data by id axios
          res = await this.getData(id)
        } catch (error) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
        }
        // assign value to item selected
        this.itemSelected = {
          id: res.id,
          name: res.name,
          description: res.description,
          discount_type: res.discount_type, // percent, baht
          start_date: res.start_date ? new Date(res.start_date) : null,
          end_date: res.end_date ? new Date(res.end_date) : null,
          set_test_id: res.set_test_id,
          test_id: res.test_id,
          type: res.type, // each, all
          value: res.value,
          product_name: res.product_name,
          active: true,
        }
        // remove loading
        this.$store.state.isLoading = false
      },
      backHandler() {
        // clear item selected
        this.itemSelected = {
          id: null,
          name: null,
          description: null,
          discount_type: 'percent', // percent, baht
          start_date: null,
          end_date: null,
          set_test_id: null,
          test_id: null,
          type: 'all', // each, all
          value: null,
          product_name: null,
          active: true,
        }
        // change content to table
        this.content = 'table'
      }
    },
  }
</script>

<style scoped>

</style>
